var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('el-container',{attrs:{"id":"mainModule-container","direction":"vertical"}},[_c('el-main',{attrs:{"id":"mainModule-main"}},[_c('router-view')],1),_c('el-header',{attrs:{"id":"mainModule-header","height":"64px"}},[_c('v-head')],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }